import {createErrorAction} from './utils';

const TYPES = {
    GET_GAME_XP_HIGHLIGHTS: 'GET_GAME_XP_HIGHLIGHTS',
    GET_GAME_XP_HIGHLIGHTS_COMPLETE: 'GET_GAME_XP_HIGHLIGHTS_COMPLETE',
    GET_GAME_XP_HIGHLIGHTS_FAILED: 'GET_GAME_XP_HIGHLIGHTS_FAILED'
};

export default {
    TYPES,

    getGameXpHighlights: payload => ({
        type: TYPES.GET_GAME_XP_HIGHLIGHTS,
        payload
    }),

    getGameXpHighlightsSuccess: payload => ({
        type: TYPES.GET_GAME_XP_HIGHLIGHTS_COMPLETE,
        payload
    }),

    getGameXpHighlightsFailed: createErrorAction(TYPES.GET_GAME_XP_HIGHLIGHTS_FAILED)
};
